var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"public-content"},[_c('div',{staticClass:"public"},[_c('ChildSideBar'),_c('div',{staticClass:"public-right"},[_c('TopBar')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }